import { VertSpacerSm } from '@apps-common/components/layout/spacers'
import { BreadcrumbItem } from '@apps-common/components/navigation'
import { commonIcons } from '@apps-common/config/icons'
import { Route } from '@apps-common/types/routes'

interface IProps {
  route: Route
}

export const Breadcrumbs: React.FC<IProps> = ({ route }) => {
  return (
    <>
      <div className='block pt-[10px]' />
      <div className='hidden sm:block'>
        <VertSpacerSm />
        <div className='flex items-center justify-start gap-[3.5px] text-text-muted'>
          <commonIcons.folder className='text-[0.9em] mb-[2px]' />
          {route && route.breadcrumbs.map((b, i) => <BreadcrumbItem key={`${b}-${i}`} label={b.label} icon={b.icon} />)}
        </div>
        <VertSpacerSm />
      </div>
    </>
  )
}
